import Http from "../helpers/Http";

class OperationService {

  getPackages(data) {
    return Http.post('/packages/manifiest/list?pageSize=1000', data);
  }

  updatePackage(data) {
    return Http.post('/packages/manifiest/update', data);
  }

  uploadFileServer(data, path = "/packages/manifiest"){
    return Http.postMultipart(path, data);
  }
  deleteRow(data){
    return Http.update('/packages/manifiest/delete', data);
  }

}

export default new OperationService();